<template>
  <div id="app">
    <div class="container-lg clearfix px-2">
      <div class="col-12">
        <div class="tabnav pt-2">
          <div class="tabnav-extra float-right">
            <ShowLocation />
          </div>
          <nav class="tabnav-tabs" aria-label="Map">
            <router-link
              to="/"
              class="tabnav-tab"
              exact-active-class="selected"
            >
              Map
            </router-link>
            <router-link
              to="/settings"
              class="tabnav-tab"
              exact-active-class="selected"
            >
              Settings
            </router-link>
          </nav>
        </div>
      </div>
    </div>
    <Flash :flash="$store.state.flashV2" />
    <router-view />
  </div>
</template>

<script>
import Flash from "./components/Flash";
import ShowLocation from "./components/ShowLocation";

export default {
  name: "MapView",
  components: {
    Flash,
    ShowLocation
  }
};
</script>

<style lang="scss">
@import "@primer/css/index.scss";

.font-weight-bold {
  font-weight: $font-weight-bold;
}
</style>
